if (!customElements.get('supplement-facts-zoom')) {
  customElements.define(
    'supplement-facts-zoom',
    class SupplementFactsZoom extends HTMLElement {
      constructor() {
        super();
        this.viewport = this.querySelector('.supplement-facts-zoom__viewport');
        this.image = this.querySelector('.supplement-facts-zoom__image');
        this.minScale = 1;
        this.maxScale = 4;
        this.scale = this.minScale;
        this.pan = { x: 0, y: 0 };

        this.suppressNextClick = false;

        this.querySelector('[data-zoom-in]').addEventListener('click', () => this.setScale(this.scale + 0.5));
        this.querySelector('[data-zoom-out]').addEventListener('click', () => this.setScale(this.scale - 0.5));
        this.querySelector('[data-zoom-reset]').addEventListener('click', () => this.reset());
        this.image.addEventListener('click', () => {
          if (this.suppressNextClick) {
            this.suppressNextClick = false;
            return;
          }
          this.setScale(this.scale >= this.maxScale ? this.minScale : this.scale + 1);
        });

        this.bindDrag();
        this.bindWheel();
      }

      setImage(src, alt) {
        if (src) this.image.src = src;
        this.image.alt = alt || '';
        this.reset();
      }

      reset() {
        this.scale = this.minScale;
        this.pan = { x: 0, y: 0 };
        this.render();
      }

      setScale(scale) {
        this.scale = Math.min(Math.max(scale, this.minScale), this.maxScale);
        if (this.scale === this.minScale) this.pan = { x: 0, y: 0 };
        this.render();
      }

      render() {
        this.image.style.transform = `translate(${this.pan.x}px, ${this.pan.y}px) scale(${this.scale})`;
        this.image.classList.toggle('is-zoomed', this.scale > this.minScale);
      }

      bindDrag() {
        const DRAG_THRESHOLD = 5;
        let dragging = false;
        let moved = false;
        let start = { x: 0, y: 0 };
        let startPan = { x: 0, y: 0 };

        this.viewport.addEventListener('pointerdown', (event) => {
          if (this.scale <= this.minScale) return;
          dragging = true;
          moved = false;
          start = { x: event.clientX, y: event.clientY };
          startPan = { ...this.pan };
          this.image.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (!moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) moved = true;
          this.pan = {
            x: startPan.x + dx,
            y: startPan.y + dy,
          };
          this.render();
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach((eventName) => {
          this.viewport.addEventListener(eventName, () => {
            if (dragging && moved) this.suppressNextClick = true;
            dragging = false;
            this.image.classList.remove('is-dragging');
          });
        });
      }

      bindWheel() {
        this.viewport.addEventListener(
          'wheel',
          (event) => {
            if (this.scale === this.minScale && event.deltaY > 0) return;
            event.preventDefault();
            this.setScale(this.scale - event.deltaY * 0.0015);
          },
          { passive: false }
        );
      }
    }
  );
}

if (!customElements.get('supplement-zoom-modal')) {
  customElements.define(
    'supplement-zoom-modal',
    class SupplementZoomModal extends ModalDialog {
      constructor() {
        super();
        this.zoomController = this.querySelector('supplement-facts-zoom');

        this.addEventListener('click', (event) => {
          if (
            event.target.closest(
              '.supplement-facts-zoom__viewport, .supplement-facts-zoom__controls, .supplement-facts-zoom-modal__toggle'
            )
          ) {
            return;
          }
          this.hide();
        });
      }

      show(opener) {
        super.show(opener);
        if (this.zoomController) {
          this.zoomController.setImage(opener.getAttribute('data-full-src'), opener.getAttribute('data-image-alt'));
        }
      }

      hide() {
        if (this.zoomController) this.zoomController.reset();
        super.hide();
      }
    }
  );
}
